import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "recurrence-selector" }
const _hoisted_2 = { class: "frequency-selector mb-3" }
const _hoisted_3 = {
  class: "btn-group w-100",
  role: "group"
}
const _hoisted_4 = { class: "interval-selector mb-3" }
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "input-group-text" }
const _hoisted_9 = { class: "count-selector mb-3" }
const _hoisted_10 = { class: "row g-2" }
const _hoisted_11 = { class: "col-auto" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "col" }
const _hoisted_15 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_16 = {
  key: 0,
  class: "weekday-selector mb-3"
}
const _hoisted_17 = { class: "weekday-buttons d-flex flex-wrap gap-1" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "monthly-options mb-3"
}
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = { class: "form-check" }
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = {
  key: 0,
  class: "monthdays-selector"
}
const _hoisted_25 = { class: "monthday-buttons d-flex flex-wrap gap-1" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "pattern-preview" }
const _hoisted_28 = { class: "bg-light p-2 rounded small" }
const _hoisted_29 = ["name", "value", "onInput"]
const _hoisted_30 = {
  key: 0,
  class: "invalid-feedback d-block"
}

import { ref, computed, watch, onMounted } from "vue";


export default {
  __name: 'RecurrenceSelector',
  props: {
	form: {
		type: Object,
		required: true,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
},
  setup(__props) {

const props = __props;

// Reactive state
const selectedFrequency = ref("weekly");
const interval = ref(1);
const count = ref(8);
const selectedWeekdays = ref([]);
const monthlyType = ref("monthly"); // 'monthly', 'monthdays', 'lastday'
const selectedMonthDays = ref([]);

// Debounce timer
let updateTimer = null;

// Constants
const weekdays = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

// Computed properties
const intervalLabel = computed(() => {
	switch (selectedFrequency.value) {
		case "daily":
			return "Intervall (Tage)";
		case "weekly":
			return "Intervall (Wochen)";
		case "monthly":
			return "Intervall (Monate)";
		default:
			return "Intervall";
	}
});

const frequencyUnit = computed(() => {
	switch (selectedFrequency.value) {
		case "daily":
			return interval.value === 1 ? "Tag" : "Tage";
		case "weekly":
			return interval.value === 1 ? "Woche" : "Wochen";
		case "monthly":
			return interval.value === 1 ? "Monat" : "Monate";
		default:
			return "";
	}
});

const patternPreview = computed(() => {
	let preview = "";

	if (selectedFrequency.value === "daily") {
		preview =
			interval.value === 1
				? `Täglich, ${count.value} Termine`
				: `Alle ${interval.value} Tage, ${count.value} Termine`;
	} else if (selectedFrequency.value === "weekly") {
		let weekdayText = "";
		if (selectedWeekdays.value.length > 0) {
			weekdayText = ` (${selectedWeekdays.value
				.map((i) => weekdays[i])
				.join(", ")})`;
		}
		preview =
			interval.value === 1
				? `Wöchentlich${weekdayText}, ${count.value} Termine`
				: `Alle ${interval.value} Wochen${weekdayText}, ${count.value} Termine`;
	} else if (selectedFrequency.value === "monthly") {
		let monthlyText = "";
		if (monthlyType.value === "monthly") {
			monthlyText = "am gleichen Tag";
		} else if (
			monthlyType.value === "monthdays" &&
			selectedMonthDays.value.length > 0
		) {
			monthlyText = `am ${[...selectedMonthDays.value]
				.sort((a, b) => a - b)
				.join(", ")}.`;
		} else if (monthlyType.value === "lastday") {
			monthlyText = "am letzten Tag";
		}

		const intervalText =
			interval.value === 1 ? "Monatlich" : `Alle ${interval.value} Monate`;
		preview = `${intervalText} ${monthlyText}, ${count.value} Termine`;
	}

	return preview;
});

// Methods
function setCount(newCount) {
	count.value = newCount;
	updatePattern();
}

function toggleWeekday(dayIndex) {
	const index = selectedWeekdays.value.indexOf(dayIndex);
	if (index > -1) {
		selectedWeekdays.value.splice(index, 1);
	} else {
		selectedWeekdays.value.push(dayIndex);
	}
	updatePattern();
}

function toggleMonthDay(day) {
	const index = selectedMonthDays.value.indexOf(day);
	if (index > -1) {
		selectedMonthDays.value.splice(index, 1);
	} else {
		selectedMonthDays.value.push(day);
	}
	updatePattern();
}

function updatePattern() {
	let rrule = "";

	// Build RRULE string
	if (selectedFrequency.value === "daily") {
		rrule = `FREQ=DAILY`;
		if (interval.value > 1) {
			rrule += `;INTERVAL=${interval.value}`;
		}
	} else if (selectedFrequency.value === "weekly") {
		rrule = `FREQ=WEEKLY`;
		if (interval.value > 1) {
			rrule += `;INTERVAL=${interval.value}`;
		}
		if (selectedWeekdays.value.length > 0) {
			// Convert to RFC format (1=Sunday, 2=Monday, etc.)
			const rfcWeekdays = selectedWeekdays.value
				.map((day) => {
					return day === 6 ? 1 : day + 2; // Convert: Mo=2, Di=3, ..., So=1
				})
				.sort();
			rrule += `;BYDAY=${rfcWeekdays
				.map((d) => ["SU", "MO", "TU", "WE", "TH", "FR", "SA"][d - 1])
				.join(",")}`;
		}
	} else if (selectedFrequency.value === "monthly") {
		rrule = `FREQ=MONTHLY`;
		if (interval.value > 1) {
			rrule += `;INTERVAL=${interval.value}`;
		}

		// Add monthly pattern specific rules
		if (
			monthlyType.value === "monthdays" &&
			selectedMonthDays.value.length > 0
		) {
			const sortedDays = selectedMonthDays.value.sort((a, b) => a - b);
			rrule += `;BYMONTHDAY=${sortedDays.join(",")}`;
		} else if (monthlyType.value === "lastday") {
			rrule += `;BYMONTHDAY=-1`;
		}
		// For 'monthly' type, no additional rules needed (uses same day as start date)
	}

	// Add count
	if (count.value > 0) {
		rrule += `;COUNT=${count.value}`;
	}

	// Update the form field
	if (props.form?.setFieldValue) {
		props.form.setFieldValue("rrulePattern", rrule);
	}
}

function handleCountInput(event) {
	// Clear any existing timer
	if (updateTimer) {
		clearTimeout(updateTimer);
	}

	const value = event.target.value;

	// If the value is empty or invalid, don't update immediately
	if (value === "" || isNaN(value)) {
		return;
	}

	// Parse the value and ensure it's within bounds
	const numValue = parseInt(value);
	if (numValue >= 1 && numValue <= 100) {
		// Debounce the update to prevent rapid firing
		updateTimer = setTimeout(() => {
			updatePattern();
		}, 300);
	}
}

function handleIntervalInput(event) {
	// Clear any existing timer
	if (updateTimer) {
		clearTimeout(updateTimer);
	}

	const value = event.target.value;

	// If the value is empty or invalid, don't update immediately
	if (value === "" || isNaN(value)) {
		return;
	}

	// Parse the value and ensure it's within bounds
	const numValue = parseInt(value);
	if (numValue >= 1 && numValue <= 30) {
		// Debounce the update to prevent rapid firing
		updateTimer = setTimeout(() => {
			updatePattern();
		}, 300);
	}
}

function parseExistingPattern(pattern) {
	if (!pattern) return;

	// Reset all options first
	selectedWeekdays.value = [];
	monthlyType.value = "monthly";
	selectedMonthDays.value = [];

	// Parse existing RRULE pattern
	const parts = pattern.split(";");

	parts.forEach((part) => {
		const [key, value] = part.split("=");

		switch (key) {
			case "FREQ":
				selectedFrequency.value = value.toLowerCase();
				break;
			case "INTERVAL":
				interval.value = parseInt(value);
				break;
			case "COUNT":
				count.value = parseInt(value);
				break;
			case "BYDAY":
				// Parse weekdays
				const days = value.split(",");
				selectedWeekdays.value = days
					.map((day) => {
						const dayMap = { MO: 0, TU: 1, WE: 2, TH: 3, FR: 4, SA: 5, SU: 6 };
						return dayMap[day];
					})
					.filter((d) => d !== undefined);
				break;
			case "BYMONTHDAY":
				// Parse month days
				const monthDays = value.split(",").map((d) => parseInt(d));
				if (monthDays.includes(-1)) {
					monthlyType.value = "lastday";
				} else {
					monthlyType.value = "monthdays";
					selectedMonthDays.value = monthDays.filter((d) => d > 0);
				}
				break;
		}
	});
}

// Initialize from existing form value
onMounted(() => {
	const existingPattern = props.form.state?.values?.rrulePattern;
	if (existingPattern) {
		parseExistingPattern(existingPattern);
	} else {
		// Set default pattern
		updatePattern();
	}
});

// Watch for external changes to the form
watch(
	() => props.form.state?.values?.rrulePattern,
	(newPattern) => {
		if (newPattern && newPattern !== buildCurrentPattern()) {
			parseExistingPattern(newPattern);
		}
	}
);

function buildCurrentPattern() {
	// Helper to build current pattern for comparison
	let rrule = `FREQ=${selectedFrequency.value.toUpperCase()}`;
	if (interval.value > 1) {
		rrule += `;INTERVAL=${interval.value}`;
	}
	if (
		selectedFrequency.value === "weekly" &&
		selectedWeekdays.value.length > 0
	) {
		const rfcWeekdays = selectedWeekdays.value
			.map((day) => {
				return day === 6 ? 1 : day + 2;
			})
			.sort();
		rrule += `;BYDAY=${rfcWeekdays
			.map((d) => ["SU", "MO", "TU", "WE", "TH", "FR", "SA"][d - 1])
			.join(",")}`;
	}
	if (selectedFrequency.value === "monthly") {
		if (
			monthlyType.value === "monthdays" &&
			selectedMonthDays.value.length > 0
		) {
			const sortedDays = selectedMonthDays.value.sort((a, b) => a - b);
			rrule += `;BYMONTHDAY=${sortedDays.join(",")}`;
		} else if (monthlyType.value === "lastday") {
			rrule += `;BYMONTHDAY=-1`;
		}
	}
	if (count.value > 0) {
		rrule += `;COUNT=${count.value}`;
	}
	return rrule;
}

// Extract form for template
const { form } = props;

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[28] || (_cache[28] = _createElementVNode("h6", { class: "mb-3" }, [
      _createElementVNode("i", { class: "fas fa-repeat me-2" }),
      _createTextVNode(" Wiederholung ")
    ], -1 /* CACHED */)),
    _createCommentVNode(" Frequency Selection "),
    _createElementVNode("div", _hoisted_2, [
      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label" }, "Häufigkeit", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          id: "freq-daily",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selectedFrequency).value = $event)),
          type: "radio",
          value: "daily",
          class: "btn-check",
          onChange: updatePattern
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelRadio, selectedFrequency.value]
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("label", {
          for: "freq-daily",
          class: "btn btn-outline-primary"
        }, " Täglich ", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          id: "freq-weekly",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((selectedFrequency).value = $event)),
          type: "radio",
          value: "weekly",
          class: "btn-check",
          onChange: updatePattern
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelRadio, selectedFrequency.value]
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("label", {
          for: "freq-weekly",
          class: "btn btn-outline-primary"
        }, " Wöchentlich ", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          id: "freq-monthly",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((selectedFrequency).value = $event)),
          type: "radio",
          value: "monthly",
          class: "btn-check",
          onChange: updatePattern
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelRadio, selectedFrequency.value]
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("label", {
          for: "freq-monthly",
          class: "btn btn-outline-primary"
        }, " Monatlich ", -1 /* CACHED */))
      ])
    ]),
    _createCommentVNode(" Interval Control "),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(intervalLabel.value), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_6, [
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "input-group-text" }, "alle", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((interval).value = $event)),
          type: "number",
          class: "form-control",
          min: "1",
          max: "30",
          disabled: __props.disabled,
          onInput: handleIntervalInput
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_7), [
          [
            _vModelText,
            interval.value,
            void 0,
            { number: true }
          ]
        ]),
        _createElementVNode("span", _hoisted_8, _toDisplayString(frequencyUnit.value), 1 /* TEXT */)
      ])
    ]),
    _createCommentVNode(" Count Control "),
    _createElementVNode("div", _hoisted_9, [
      _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label" }, "Anzahl Termine", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((count).value = $event)),
              type: "number",
              class: "form-control",
              min: "1",
              max: "100",
              disabled: __props.disabled,
              onInput: handleCountInput
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13), [
              [
                _vModelText,
                count.value,
                void 0,
                { number: true }
              ]
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "input-group-text" }, "Termine", -1 /* CACHED */))
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary btn-sm",
              onClick: _cache[5] || (_cache[5] = $event => (setCount(7)))
            }, " 7x "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary btn-sm",
              onClick: _cache[6] || (_cache[6] = $event => (setCount(8)))
            }, " 8x "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary btn-sm",
              onClick: _cache[7] || (_cache[7] = $event => (setCount(14)))
            }, " 14x "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary btn-sm",
              onClick: _cache[8] || (_cache[8] = $event => (setCount(15)))
            }, " 15x ")
          ])
        ])
      ])
    ]),
    _createCommentVNode(" Weekday Selection (for weekly) "),
    (selectedFrequency.value === 'weekly')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _cache[19] || (_cache[19] = _createElementVNode("label", { class: "form-label" }, "Wochentage", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekdays, (day, index) => {
              return _createElementVNode("button", {
                key: index,
                type: "button",
                class: _normalizeClass(["btn btn-sm", 
            selectedWeekdays.value.includes(index) ? 'btn-info' : 'btn-outline-info'
          ]),
                onClick: $event => (toggleWeekday(index))
              }, _toDisplayString(day), 11 /* TEXT, CLASS, PROPS */, _hoisted_18)
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("small", { class: "form-text text-muted" }, " Leer lassen für den gleichen Wochentag wie das Startdatum ", -1 /* CACHED */))
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Monthly Pattern Selection (for monthly) "),
    (selectedFrequency.value === 'monthly')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _cache[26] || (_cache[26] = _createElementVNode("label", { class: "form-label" }, "Monatliches Muster", -1 /* CACHED */)),
          _createCommentVNode(" Monthly Pattern Type "),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                id: "monthly-same-day",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((monthlyType).value = $event)),
                type: "radio",
                value: "monthly",
                class: "form-check-input",
                onChange: updatePattern
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelRadio, monthlyType.value]
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("label", {
                for: "monthly-same-day",
                class: "form-check-label"
              }, " Am gleichen Tag des Monats ", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                id: "monthly-specific-days",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((monthlyType).value = $event)),
                type: "radio",
                value: "monthdays",
                class: "form-check-input",
                onChange: updatePattern
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelRadio, monthlyType.value]
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("label", {
                for: "monthly-specific-days",
                class: "form-check-label"
              }, " An bestimmten Tagen des Monats ", -1 /* CACHED */))
            ]),
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                id: "monthly-last-day",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((monthlyType).value = $event)),
                type: "radio",
                value: "lastday",
                class: "form-check-input",
                onChange: updatePattern
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [_vModelRadio, monthlyType.value]
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("label", {
                for: "monthly-last-day",
                class: "form-check-label"
              }, " Am letzten Tag des Monats ", -1 /* CACHED */))
            ])
          ]),
          _createCommentVNode(" Month Days Selection "),
          (monthlyType.value === 'monthdays')
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label" }, "Tage des Monats auswählen", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (day) => {
                    return _createElementVNode("button", {
                      key: day,
                      type: "button",
                      class: _normalizeClass(["btn btn-sm", 
              selectedMonthDays.value.includes(day)
                ? 'btn-warning'
                : 'btn-outline-warning'
            ]),
                      onClick: $event => (toggleMonthDay(day))
                    }, _toDisplayString(day), 11 /* TEXT, CLASS, PROPS */, _hoisted_26)
                  }), 64 /* STABLE_FRAGMENT */))
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("small", { class: "form-text text-muted" }, " Wählen Sie die Tage des Monats aus (1-31). Nicht existierende Tage werden übersprungen. ", -1 /* CACHED */))
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Preview "),
    _createElementVNode("div", _hoisted_27, [
      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "form-label" }, "Vorschau", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_28, _toDisplayString(patternPreview.value), 1 /* TEXT */)
    ]),
    _createCommentVNode(" Hidden field for TanStack Form "),
    _createVNode(_unref(form).Field, { name: "rrulePattern" }, {
      default: _withCtx(({ field }) => [
        _createElementVNode("input", {
          type: "hidden",
          name: field.name,
          value: field.state.value,
          onInput: (e) => field.handleChange(e.target.value)
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_29),
        (field.state.meta.errors.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(field.state.meta.errors[0]), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

}